import type { InjectionKey, Ref } from 'vue';
import type { IFolderItem } from '../services/folder.service';

export interface IFolderListOpenedInjectedProps {
  openedFolders: Ref<Record<IFolderItem['id'], boolean>>;
  toggleFolder: (folderId: string) => void;
}

export const FOLDER_LIST_OPENED_INJECT_KEY = Symbol(
  'FOLDER_LIST_OPENED_INJECT_KEY'
) as InjectionKey<Readonly<IFolderListOpenedInjectedProps>>;

export interface IFolderListDraggedOverInjectedProps {
  draggedOverFolder: Readonly<Ref<string | null>>;
  setDraggedOverFolder: (folderId: string | null) => void;
}

export const FOLDER_LIST_DRAGGED_OVER_INJECT_KEY = Symbol(
  'FOLDER_LIST_DRAGGED_OVER_INJECT_KEY'
) as InjectionKey<Readonly<IFolderListDraggedOverInjectedProps>>;
